import { createSlice } from '@reduxjs/toolkit'

import { ManagementOrganizationDto } from 'types/dto/ManagementOrganization.dto'
import { ManagementOrganizationMembership, UserBaseInfo } from 'types/userTypes'

import { paveApi } from 'api'
import { getIsViewOnlyUser } from 'utils/userUtils'

export interface UserState {
  userId: string | null
  email: string | null
  firstName: string | null
  lastName: string | null
  countryOfBirth: string | null
  contactInfo: any
  managementOrganizationId: string | null
  underReview: boolean | null
  isViewOnly: boolean
  managementOrganizationMemberships: ManagementOrganizationMembership[]
  members: UserBaseInfo[]
}
const initialState: UserState = {
  userId: null,
  email: null,
  firstName: null,
  lastName: null,
  managementOrganizationId: null,
  contactInfo: {},
  countryOfBirth: null,
  underReview: null,
  managementOrganizationMemberships: [],
  isViewOnly: false,
  members: [],
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const {
        id,
        firstName,
        lastName,
        email,
        managementOrganizationId,
        contactInfo,
        countryOfBirth,
        underReview,
        managementOrganizationMemberships,
      } = action.payload

      state.userId = id
      state.email = email
      state.firstName = firstName
      state.lastName = lastName
      state.countryOfBirth = countryOfBirth
      state.managementOrganizationId = managementOrganizationId
      state.contactInfo = contactInfo
      state.underReview = underReview
      state.managementOrganizationMemberships =
        managementOrganizationMemberships
    },
    resetUser: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      paveApi.endpoints.getUserById.matchFulfilled,
      (state, action) => {
        const {
          id,
          firstName,
          lastName,
          email,
          managementOrganizationId,
          contactInfo,
          countryOfBirth,
          underReview,
          managementOrganizationMemberships,
          managementOrganization,
        } = action.payload

        const memberships: ManagementOrganizationMembership[] =
          managementOrganizationMemberships.reduce(
            (
              acc: ManagementOrganizationMembership[],
              membership: ManagementOrganizationDto
            ) => {
              const { firstName, lastName, email } = membership.owner
              acc.push({
                managementOrganizationId: membership.id,
                firstName,
                lastName,
                email,
              })
              return acc
            },
            []
          )

        state.userId = id
        state.email = email
        state.firstName = firstName
        state.lastName = lastName
        state.countryOfBirth = countryOfBirth
        state.managementOrganizationId = managementOrganizationId
        state.contactInfo = contactInfo
        state.underReview = underReview
        state.managementOrganizationMemberships = memberships
        state.isViewOnly = getIsViewOnlyUser(managementOrganizationMemberships)
        state.members = managementOrganization?.members
      }
    )
  },
})

export const { setUser, resetUser } = userSlice.actions

export default userSlice.reducer
